import EnquiriesManagement from '../EnquiriesManagement';

const ServicesEnquiries = () => {
  return <EnquiriesManagement serviceType="general" />;
};

export default ServicesEnquiries;